const data = JSON.parse(document.querySelector('#ProductJson-product-template').innerHTML)

export default data
